import Plyr from 'plyr';
/**
 * Video Class
 * @class Video
 */

 export default class Video {
    constructor(item) {
        new Plyr(item.querySelector('.video__player'));
    }
}